export default __webpack_public_path__ + "static/media/Dust Collector and Ducting.8ee767ba.jpg";